import { render, staticRenderFns } from "./CompanySPVerificationEmail.vue?vue&type=template&id=7c316ca7&scoped=true"
import script from "./CompanySPVerificationEmail.vue?vue&type=script&lang=js"
export * from "./CompanySPVerificationEmail.vue?vue&type=script&lang=js"
import style0 from "./CompanySPVerificationEmail.vue?vue&type=style&index=0&id=7c316ca7&prod&lang=scss"
import style1 from "./CompanySPVerificationEmail.vue?vue&type=style&index=1&id=7c316ca7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c316ca7",
  null
  
)

export default component.exports